import axiosConfig from './Config';


const CertificateSurvey ={
    get: () => axiosConfig.get(`get-question`),
    createSurvey: (data) => axiosConfig.post(`add-survey-answer`, data),

}

export default CertificateSurvey;